// @ts-nocheck
import { createContext } from 'react'

export const MarketStatusContext = createContext(null)

